export default {
    data() {
        return {
            planData: {
                planDto: {},
                pendingStatisDto: {
                    readyDataDto: {},
                    unReadyDataDto: {}
                },
                lastingStatisDto: {

                },
                teamList: []
            },
            loading: false,
            isKtPlan: '0min',
            dialogData: {
                titleText: this.$t('planLxDetail.XYGL'),
                addLxDialog: false,
                dialogWidth: '1100px'
            },
            dialogDataLeader: {
                titleText: this.$t('planLxDetail.XZDZ'),
                addLxDialog: false,
                dialogWidth: '900px'
            },
            dialogDataPlan: {
                titleText: this.$t('planLxDetail.XGLX'),
                addLxDialog: false,
            },
            dialogOptions: [],
            dialogSelectValue: '',
            leftHeaderVal: '',
            rightHeaderVal: '',
            leftTableData: [],
            rightTableData: [],
            tableHeader: [
                { prop: 'index', label: this.$t('planLxDetail.XH1'), width: '50' },
                { prop: 'name', label: this.$t('planLxDetail.XM') },
                { prop: 'studentNumber', label: this.$t('planLxDetail.ID') }
            ],
            rightTableHeader: [
                { prop: 'index', label: this.$t('planLxDetail.XH1'), width: '50' },
                { prop: 'playerName', label: this.$t('planLxDetail.XM') },
                { prop: 'playerNo', label: this.$t('planLxDetail.ID') }
            ],
            total: 0,
            pageNo: 1,
            planId: null,
            activeTableData: [],
            removeActiveTableData: [],
            leaderInputVal: '',
            leaderTableData: [],
            leaderTableDataAll: [],
            activeLeaderList: [],
            selectLeaderList: [], // 选中队长记录
            maxPersonCount: '0',
            scheduleDialogVisible: false,
            resetData: {}
        }
    },
    created() {
        let { id, planId } = JSON.parse(this.__Base64.decode(this.$route.query.q))
        this.planId = id || planId
    },
}